import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const errorMessages = {
    ru: 'Обязательное поле!',
    en: 'Required field!',
    kk: 'Міндетті өріс!',
};

const Recaptcha = forwardRef((props: any, ref) => {
    const [recaptcha, setRecaptcha] = useState({ verified: false, error: '' });
    const captchaRef = useRef<ReCAPTCHA | null>(null); // Создаём реф для компонента ReCAPTCHA
    let lang = 'ru';

    if (props.lang && ['en', 'kk'].includes(props.lang)) {
        lang = props.lang;
    }

    const setError = () => {
        setRecaptcha({
            verified: false,
            error: errorMessages[lang],
        });
    };

    const onVerify = (token: string | null) => {
        if (token) {
            localStorage.setItem('recaptchaToken', token);
            setRecaptcha({
                verified: true,
                error: '',
            });
        }
    };

    // Функция для сброса reCAPTCHA
    const reset = () => {
        if (captchaRef.current) {
            captchaRef.current.reset(); // Вызываем метод сброса reCAPTCHA
        }

        setRecaptcha({
            verified: false,
            error: '',
        });
    };

    useImperativeHandle(
        ref,
        () => ({
            getValue: () => recaptcha,
            setError: () => setError(),
            reset: () => reset(),
        }),
        [recaptcha]
    );

    return (
        <div>
            <ReCAPTCHA
                ref={captchaRef}
                sitekey="6LfRIQUjAAAAAJubHscWUTJLeueGLHYRHTYkIZ7Z"
                onChange={onVerify}
                onExpired={setError}
                onErrored={setError}
                hl={lang}
            />
            <div className="text-danger">{recaptcha.error}</div>
        </div>
    );
});

export default Recaptcha;
